import { ToggleProps, Root as ToggleRoot } from '@radix-ui/react-toggle';

import styles from './ToggleSwitch.module.scss';

export type ToggleSwitchProps = ToggleProps & {
  disabled?: boolean;
};

export const ToggleSwitch = ({ ...props }: ToggleSwitchProps) => {
  return (
    <ToggleRoot {...props} className={styles.container}>
      <div className={`${styles.switch} ${props.pressed && styles.active} ${props.disabled && styles.disable}`}></div>
    </ToggleRoot>
  );
};
